import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import SettingsIcon from "@material-ui/icons/Settings";
import Spinner from "react-bootstrap/Spinner";
import { ModalPersonalizar } from "./ModalPersonalizar";
import { ModalNuevoTratamiento } from "./ModalNuevo";
import {
  Tabla,
  TablaHeader,
  TablaHeaderTexto,
  TablaBody,
  TablaBodyTexto,
  StyledInput,
  MainContainer,
  ContainerTitle,
  ContainerTitleText,
  ContainerBody,
  StyledLabel,
  ContainerButton,
  ButtonAbonar,
  ContainerTitles,
  InputColor,
  StyledInputTabla,
  ListContainer,
  CardsGrid,
  TratamientoCardWrapper


} from "./styles";

import TratamientoCard from "./TratamientoCard";

import {
  fetchTratamientosCompletosThunk,
  personalizarTratamientoBase,
  updateTratamiento,
  updateTratamientoInArray,
} from "../../redux/tratamientos/tratamientosActions";
import { fetchSubGrupos } from "../../redux/subGrupos/subGruposActions";

// Hook para búsqueda
export const useBuscarTratamientos = (tratamientos) => {
  const [query, setQuery] = useState("");
  const [filteredItems, setFilteredItems] = useState(tratamientos || []);

  useEffect(() => {
    let result = tratamientos || [];
    if (query.length > 0) {
      result = result.filter((item) =>
        `${item.tratamiento} ${item.tipo} ${item.especialidad}`.toLowerCase().includes(query.toLowerCase())
      );
    }
    setFilteredItems(result);
  }, [tratamientos, query]);

  return { query, setQuery, filteredItems };
};




export const Tratamientos = () => {
  const dispatch = useDispatch();
  const sesion = useSelector((state) => state.sesion);
  const tratamientos = useSelector((state) => state.tratamientos);
  const subGrupos = useSelector((state) => state.subGrupos);
  const empresa = useSelector((state) => state.empresa);
  const history = useHistory();
  const { query, setQuery, filteredItems } = useBuscarTratamientos(tratamientos);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [tratamientoEnEdicion, setTratamientoEnEdicion] = useState(null);
  const [nuevoTratamientoModal, setNuevoTratamientoModal] = useState(false);

  useEffect(() => {
    if (empresa?.id) {
      dispatch(fetchTratamientosCompletosThunk(empresa.id));
    }
    if (!subGrupos.length) {
      dispatch(fetchSubGrupos());
    }
  }, [empresa?.id, dispatch, subGrupos.length]);

  const abrirModalPersonalizar = (tratamiento) => {
    console.log("Abriendo modal para:", tratamiento);
    setTratamientoEnEdicion(tratamiento);
    setModalAbierto(true);
  };

  const cerrarModal = (personalizado) => {
    setModalAbierto(false);
    if (personalizado) {
      dispatch(updateTratamientoInArray(personalizado));
    }
  };

  if (sesion.loading || sesion.loading === undefined) {
    return (
      <MainContainer style={{ display: "flex", justifyContent: "center", padding: 50 }}>
        <Spinner animation="border" role="status" />
      </MainContainer>
    );
  }
 console.log("Tratamientos filtradosX:", filteredItems);
  const tratamientosFiltrados = filteredItems.filter((item) => 
    item.origen === "base" || item.origen === "personalizado"
  );
  console.log("Tratamientos filtradosY:", tratamientosFiltrados);

  return (
    <MainContainer>
      <ContainerTitle>
        <ContainerTitleText>Catálogo de Tratamientos</ContainerTitleText>
      </ContainerTitle>

      <ContainerButton>
        <ContainerTitles>
          <StyledLabel>Buscar tratamiento</StyledLabel>
          <StyledInput 
            type="text" 
            value={query} 
            onChange={(e) => setQuery(e.target.value)} 
            placeholder="Buscar por nombre, tipo o especialidad..." 
          />
        </ContainerTitles>

        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <ButtonAbonar onClick={() => setNuevoTratamientoModal(true)}>
            Nuevo Tratamiento
          </ButtonAbonar>
        </div>
      </ContainerButton>

      <ContainerBody>
        

  <ListContainer>
      <CardsGrid className={tratamientosFiltrados.length > 5 ? 'scroll-safe' : ''}>
        {tratamientosFiltrados.map((item, index) => (
          <TratamientoCardWrapper key={item.id} esBase={item.origen === "base"}>
            <TratamientoCard 
      key={item.id} 
      idx={index}
      item={item}
      subGrupos={subGrupos}
      onPersonalizar={abrirModalPersonalizar}
    />
          </TratamientoCardWrapper>
        ))}
      </CardsGrid>
    </ListContainer>
     
      </ContainerBody>

      <ModalPersonalizar
        isOpen={modalAbierto}
        tratamientoBase={tratamientoEnEdicion}
        empresaId={empresa?.id}
        onClose={cerrarModal}
      />

      <ModalNuevoTratamiento
        isOpen={nuevoTratamientoModal}
        empresaId={empresa?.id}
        onClose={() => {setNuevoTratamientoModal(false);          
        }}
      />

    </MainContainer>
  );
};